import { outreachStatus } from '@/constants/outreach-status';
import { KText } from '@/ui-library/components';
import { Box, Center, Flex } from '@chakra-ui/react';
import { Send01 } from '@kula-ai/icons-core';
import { FlowItem as FlowItemType } from '../types';
import { SearchItemWrapper } from './SearchItemWrapper';
import { Link } from 'react-router-dom';
import { useSearchManager } from '../search-manager';
import { HighlightedTooltipText } from '../text';

interface FlowItemProps {
  item: FlowItemType;
}

export const FlowItem = ({ item }: FlowItemProps) => {
  const { title, status, id } = item;
  const statusColor =
    status === 'active'
      ? '#73D017'
      : outreachStatus?.[status]?.color || 'pastel-2-dark';
  const { onSearchClose, searchTerm } = useSearchManager();

  return (
    <Link
      to={`/outreaches/${id}`}
      style={{ textDecoration: 'none' }}
      onClick={() => {
        onSearchClose();
      }}
    >
      <SearchItemWrapper>
        <Flex alignItems="center" gap="12px">
          <Center
            width="36px"
            height="36px"
            borderRadius="xs"
            bg="pastel-2-light"
          >
            <Send01
              size="1rem"
              color="var(--kula-colors-pastel-2-dark)"
              className="kula-icon"
            />
          </Center>
          <HighlightedTooltipText
            variant="heading_3"
            color="primary-900"
            highlight={searchTerm}
            text={title}
          />
          <KText
            variant="paragraph"
            color="secondary-700"
            p="1px 8px"
            borderRadius="xs"
            border="1px solid"
            borderColor="secondary-100"
            textTransform="capitalize"
            display="flex"
            alignItems="center"
            gap="4px"
            lineHeight="20px"
            ml="-6px"
          >
            <Box bg={statusColor} borderRadius="full" w="8px" h="8px" />
            {status}
          </KText>
        </Flex>
      </SearchItemWrapper>
    </Link>
  );
};
